import React from 'react';

import usePageLayout from '@/components/PageLayout/usePageLayout';

import EditorHeaderLeftNode from './components/EditorHeaderLeftNode';
import EditorHeaderRightNode from './components/EditorHeaderRightNode';
import { HeaderProps } from './types';

type ContentEditorHeaderProps = HeaderProps;

const Header: React.FC<ContentEditorHeaderProps> = ({
  status,
  title,
  onBack,
  publishProps,
  disabled,
  isArchived,
  isEditMode,
  onSaveDraft,
  onSaveDraftAndPreview,
  onSubmit,
  settings,
  workspaceSubject,
  contentType,
  showSavingState,
  saving,
  workspaceAction,
  id,
  allowMinorVersionPublish,
  path,
  setDefaultLanguageType,
  defaultLanguageType,
}) => {
  usePageLayout({
    className: 'ps-24 pe-12',
    title,
    LeftNode: <EditorHeaderLeftNode status={status} title={title} onBack={onBack} />,
    RightNode: (
      <EditorHeaderRightNode
        allowMinorVersionPublish={allowMinorVersionPublish}
        contentType={contentType}
        defaultLanguageType={defaultLanguageType}
        disabled={disabled}
        id={id}
        isArchived={isArchived}
        isEditMode={isEditMode}
        path={path}
        publishProps={publishProps}
        saving={saving}
        setDefaultLanguageType={setDefaultLanguageType}
        settings={settings}
        showSavingState={showSavingState}
        status={status}
        workspaceAction={workspaceAction}
        workspaceSubject={workspaceSubject}
        onSaveDraft={onSaveDraft}
        onSaveDraftAndPreview={onSaveDraftAndPreview}
        onSubmit={onSubmit}
      />
    ),
    showNavigationTabs: false,
  });

  return null;
};

export default React.memo(Header);
